import { connect } from 'react-redux';
import Carriers from './Carriers';

const mapState = state => ({
  carriers: state.loadingManagement.customerAuthorizations.customerAuthorization.carriers,
});

const mapDispatchToProps = {};

export default connect(mapState, mapDispatchToProps)(Carriers);
